import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import DescriptionIcon from "@mui/icons-material/Description";
import "./StudentProfile.css";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { handleApplicationSelect } from "../../../pages/manage/hierarchy/FormFixture";
import { compoenentRenderFrom, namespace } from "../../../helper/namespace";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import Tooltip from '@mui/material/Tooltip';

const CourseDetails = ({ courseDetail }) => {
  const location = useLocation();

  const handleRedirect = (formData) => {
    handleApplicationSelect(
      formData.pid,
      formData.node_mid,
      formData.lg_user_id,
      formData.lg_user_table_id,
      formData.flg_list_active,
      formData.privilege_view,
      formData.privilege_edit,
      formData.privilege_add,
      formData.privilege_delete,
      formData.owner_restriction,
      formData.user_list_restriction,
      formData.form_display_title,
      formData.form_display_order,
      formData.form_list_id,
      formData.breadcrumb,
      formData.main_table_id,
      formData.tree_main_title,
      formData.node_mid_actual,
      compoenentRenderFrom.STUDENT_PROFILES,
      formData.mcode,
      location.state
    );
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "Pending":
        return "clrPending";
      case "Ongoing":
        return "clrOngoing";
      case "On Hold":
        return "clrOnHold";
      case "Completed":
        return "clrCompleted";
      case "Certificate Collected":
        return "clrCertificateCollected";
      case "Withdrawn":
        return "clrWithdrawn";
      case "Failed to Complete":
        return "clrFailedToComplete";
      default:
        return "";
    }
  };

  return (
    <Table sx={{}} aria-label="simple table">
      <TableHead>
        <TableRow>
          <TableCell className="tblCell" align="center">
            Courses Enrolled{" "}
          </TableCell>
          <TableCell className="tblCell" align="center">
            Batch
          </TableCell>
          <TableCell className="tblCell" align="center">
            Enrolled Date
          </TableCell>
          <TableCell className="tblCell" align="center">
          Course Status
          </TableCell>
          <TableCell className="tblCell" align="center">
            Action
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {courseDetail?.map((row, index) => (
          <TableRow
            key={index}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          >
            {/* <TableCell className='tblCell' component="th" scope="row">
              {row.courses}
              </TableCell> */}
             <Tooltip title={<strong>{row.form_display_title}</strong>} arrow>
            <div className="courseEnolled">
              <TableCell
                className="tblCell stdcourses fullWidth d-flex justify-content-start"
                align="center"
              >
                <DescriptionIcon className="desc-icon" />
                &nbsp;{`${row.breadcrumb}${row.tree_main_title}`}
              </TableCell>
            </div>
          </Tooltip>
            <TableCell className="tblCell" align="center">
              {row.group_text2}
            </TableCell>
            <TableCell className="tblCell" align="center">
              {row.enroll_start_date}
            </TableCell>
            <TableCell className="tData">
              <span
                className={`status ${getStatusClass(row.enrollment_status)}`}
              >
                {row.enrollment_status}
              </span>
            </TableCell>
            <TableCell className="tblCell" align="center">
              <button
                className="tblCell stdcourses"
                onClick={() => handleRedirect(row)}
              >
                <ArrowForwardIcon />
              </button>{" "}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default CourseDetails;
